import React, { useEffect, useState } from "react";
import "./Cocina.css";
import HourSummary from "../../components/template/HourSummary";
import OrdersTable from "../../components/template/OrdersTable";
import OrderDetail from "../../components/template/OrderDetail";
import SummaryCard from "../../components/template/SummaryCard";
// import TimelineItem from "../../components/template/TimelineItem";
import {
  collection,
  doc,
  onSnapshot,
  orderBy,
  query,
  Timestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import { v4 as uuidv4 } from "uuid";
import { projectFirestore } from "../../firebase/config";
import { useAuthContext } from "../../hooks/useAuthContext";
import {
  Accordion,
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  useAccordionButton,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import Board from "../../components/Board";
import { addNotifyOrden } from "../../util/UtilsFirebase";

const Cocina = () => {
  const { register } = useAuthContext();
  const [orders, setOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState();
  const [vista, setVista] = useState(1);
  const [marOrd, setMarOrd] = useState();
  const [summary, setSummary] = useState({});
  const [summaryday, setSummaryDay] = useState({});
  const [selectedDay, setSelectedDay] = useState();
  const [selectedHour, setSelectedHour] = useState("cantidad");
  const [verificar, setVerificar] = useState(false);
  const [mostrarord, setMostrarord] = useState(true);

  function CustomToggle({ text, eventKey }) {
    const decoratedOnClick = useAccordionButton(eventKey, () => {
      setMostrarord(!mostrarord);
    });
    return (
      <h4 className="section-title" onClick={decoratedOnClick}>
        RESUMEN DEL DIA{" "}
        {mostrarord ? (
          <FontAwesomeIcon icon={faArrowUp} />
        ) : (
          <FontAwesomeIcon icon={faArrowDown} />
        )}
      </h4>
    );
  }

  const selectOrder = (ord) => {
    if (ord === selectedOrder) {
      setSelectedOrder();
    } else {
      setSelectedOrder(ord);
    }
  };

  const selectDay = (day) => {
    setSelectedDay(day);
    setSelectedHour("cantidad");
    setSelectedOrder();
  };

  const selectHour = (hour) => {
    setSelectedHour(hour);
    setSelectedOrder();
  };

  const preEntregado = (ord) => {
    setMarOrd(ord);
    setVerificar(true);
  };

  const updateStatus = () => {
    updateDoc(doc(projectFirestore, "turnero", marOrd.id), {
      status: "ENTREGAR",
    });
    setMarOrd();
    setVerificar();
  };

  const updatePlatillo = async (
    idOrd,
    platillos,
    nstatus,
    motivo,
    observacion,
  ) => {
    let ord = orders.find((itb) => itb.id === idOrd);
    let modificados = 0;
    if (ord) {
      platillos.forEach((itemplat) => {
        ord.detalle = ord.detalle.map((item) => {
          if (
            item.idv4 === itemplat.idv4 &&
            ((item.status !== nstatus && item.status !== "CANCELADO") ||
              (nstatus === "ATENDIDO" && item.status === "CANCELADO"))
          ) {
            modificados++;
            if (observacion) {
              return {
                ...item,
                status: nstatus,
                motivo: motivo,
                observacion: observacion,
              };
            } else {
              return {
                ...item,
                status: nstatus,
              };
            }
          } else {
            return item;
          }
        });
      });
      if (
        ord.detalle.filter((item) => item.status !== "CANCELADO").length === 0
      ) {
        ord.status = "CANCELADO";
      } else if (
        ord.detalle.filter(
          (item) => item.status !== "CANCELADO" && item.status !== "ENTREGADO",
        ).length === 0
      ) {
        ord.status = "COMPLETADO";
      }
      if (ord && modificados > 0) {
        await updateDoc(doc(projectFirestore, "turnero", ord.id), {
          detalle: ord.detalle,
          status: ord.status,
        });
        const notificacion = {
          idv4: uuidv4(),
          turno_id: ord.id,
          user: ord.user,
          user_name: ord.user_name,
          status: "AVISO",
          number: ord.number,
          puesto_name: ord.puesto_name,
          tipo_pago: ord.tipo_pago,
          active: true,
          pending: true,
          fecha: Timestamp.now(),
        };
        if (nstatus === "CANCELADO") {
          notificacion.description =
            modificados +
            " de tus platillos " +
            (modificados > 1 ? "han" : "ha") +
            " sido " +
            (modificados > 1 ? "cancelados" : "cancelado") +
            ' por el motivo "' +
            motivo +
            '"';
        } else if (nstatus === "ENTREGAR") {
          notificacion.description =
            modificados +
            " de tus platillos te " +
            (modificados > 1 ? "estan" : "esta") +
            " esperando! pasa a mostrador";
        } else if (nstatus === "ENTREGADO") {
          notificacion.description =
            modificados +
            " de tus platillos " +
            (modificados > 1 ? "han" : "ha") +
            " sido entregado, que lo disfrutes!";
        }
        if (notificacion.description) {
          addNotifyOrden(notificacion);
        }
      }
    }
  };

  useEffect(() => {
    let fechaact = new Date();
    setSelectedDay(fechaact.toISOString().split("T")[0]);
    fechaact.setDate(fechaact.getDate() - 7);
    const filtros = [
      { campo: "puesto", operador: "==", valor: register.id },
      { campo: "fecha", operador: ">=", valor: fechaact },
      { campo: "status", operador: "==", valor: "ATENDIDO" },
    ];
    let q = query(collection(projectFirestore, "turnero"));
    filtros.forEach((filtro) => {
      const { campo, operador, valor } = filtro;
      q = query(q, where(campo, operador, valor));
    });
    q = query(q, orderBy("fecha", "desc"));
    let escucha = onSnapshot(q, (docs) => {
      const documentosColeccion = [];
      let numAtendido = 0;
      let sum = {};
      let sumday = {};
      docs.docs.forEach((docu) => {
        const data = docu.data();
        data.id = docu.id;
        data?.detalle?.forEach((element) => {
          if (element.recoger) {
            if (sumday[element.selectedDate]) {
              sumday[element.selectedDate].cantidad++;
              if (sumday[element.selectedDate][element.selectedTime]) {
                sumday[element.selectedDate][element.selectedTime].cantidad++;
              } else {
                sumday[element.selectedDate][element.selectedTime] = {
                  cantidad: 1,
                };
              }
            } else {
              sumday[element.selectedDate] = { cantidad: 1 };
              sumday[element.selectedDate][element.selectedTime] = {
                cantidad: 1,
              };
            }
            if (
              sum[element.selectedDate] &&
              sum[element.selectedDate][element.id]
            ) {
              sum[element.selectedDate][element.id].cantidad += parseInt(
                element.cantidad,
              );
              sum[element.selectedDate][element.id].orders++;
            } else {
              if (!sum[element.selectedDate]) {
                sum[element.selectedDate] = {};
              }
              sum[element.selectedDate][element.id] = {
                name: element.name,
                cantidad: parseInt(element.cantidad),
                orders: 1,
                img: element.img,
              };
            }
          } else {
            let fech = new Date(data.fecha.seconds * 1000);
            let dateord = fech.toISOString().split("T")[0];
            let hora = fech.toLocaleTimeString([], {
              hour: "2-digit",
              minute: "2-digit",
              hour12: false, // Set to true for AM/PM
            });
            if (sumday[dateord]) {
              sumday[dateord].cantidad++;
              if (sumday[dateord][hora]) {
                sumday[dateord][hora].cantidad++;
              } else {
                sumday[dateord][hora] = { cantidad: 1 };
              }
            } else {
              sumday[dateord] = { cantidad: 1 };
              sumday[dateord][hora] = { cantidad: 1 };
            }
            if (sum[dateord] && sum[dateord][element.id]) {
              sum[dateord][element.id].cantidad += parseInt(element.cantidad);
              sum[dateord][element.id].orders++;
            } else {
              if (!sum[dateord]) {
                sum[dateord] = {};
              }
              sum[dateord][element.id] = {
                name: element.name,
                cantidad: parseInt(element.cantidad),
                orders: 1,
                img: element.img,
              };
            }
          }
        });
        if (data.status && data.status === "ATENDIDO") {
          numAtendido++;
        }
        documentosColeccion.push(data);
      });
      document.title = "Cocina (" + numAtendido + ")";
      setOrders(documentosColeccion);
      setSummary(sum);
      setSummaryDay(sumday);
    });
    return escucha;
  }, [register.id]);

  return (
    <div className="container">
      <Row>
        <Col md={summary && summary[selectedDay] ? 6 : 12}>
          <h4 className="section-title">DIA</h4>
          <div className="hours-grid">
            {summaryday &&
              Object.keys(summaryday)
                .sort((a, b) => {
                  const [dayA, monthA, yearA] = a.split("-");
                  const [dayB, monthB, yearB] = b.split("-");

                  const dateA = new Date(`${dayA}-${monthA}-${yearA}`);
                  const dateB = new Date(`${dayB}-${monthB}-${yearB}`);

                  return dateA - dateB;
                })
                .map((day) => (
                  <HourSummary
                    key={day}
                    text={day}
                    selected={selectedDay}
                    hour={summaryday[day]}
                    select={selectDay}
                  />
                ))}
          </div>
        </Col>
        {summary && summary[selectedDay] && (
          <Col md={6}>
            <h4 className="section-title">HORA</h4>
            <div className="hours-grid">
              {summary &&
                summary[selectedDay] &&
                Object.keys(summaryday[selectedDay]).map((day) => (
                  <HourSummary
                    key={day}
                    text={day}
                    selected={selectedHour}
                    hour={summaryday[selectedDay][day]}
                    select={selectHour}
                  />
                ))}
            </div>
          </Col>
        )}
      </Row>

      <>
        {selectedDay && summary && summary[selectedDay] && (
          <Accordion defaultActiveKey={"resumen"}>
            <CustomToggle eventKey={"resumen"} />
            <Accordion.Collapse eventKey="resumen">
              <scroll className="summary-grid">
                {summary &&
                  summary[selectedDay] &&
                  Object.keys(summary[selectedDay]).map((item) => (
                    <SummaryCard key={item} item={summary[selectedDay][item]} />
                  ))}
              </scroll>
            </Accordion.Collapse>
          </Accordion>
        )}
        {/* <div className="botones-pestana">
          <button onClick={() => setVista(0)}>Vista 1</button>
          <button onClick={() => setVista(1)}>Vista 2</button>
        </div> */}
        {vista === 0 ? (
          <>
            {selectedDay && selectedHour && (
              <>
                <h4 className="section-title">
                  DETALLE DE PEDIDOS - {selectedDay}{" "}
                  {selectedHour === "cantidad" ? "Todo" : selectedHour} (
                  {selectedHour === "cantidad"
                    ? summaryday[selectedDay]?.cantidad
                    : summaryday[selectedDay][selectedHour]?.cantidad}{" "}
                  platillos)
                </h4>
                <OrdersTable
                  orders={orders.filter((item) => {
                    let ret = false;
                    item.detalle.forEach((ite) => {
                      if (
                        ite.selectedDate === selectedDay &&
                        (ite.selectedTime === selectedHour ||
                          selectedHour === "cantidad")
                      ) {
                        ret = true;
                      }
                      let fech = new Date(item.fecha.seconds * 1000);
                      let dateord = fech.toISOString().split("T")[0];
                      let hora = fech.toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false, // Set to true for AM/PM
                      });
                      if (
                        !ite.selectedDate &&
                        dateord === selectedDay &&
                        (hora === selectedHour || selectedHour === "cantidad")
                      ) {
                        ret = true;
                      }
                    });
                    return ret;
                  })}
                  selectOrder={selectOrder}
                  entregarOrder={preEntregado}
                  selectedDay={selectedDay}
                  selectedHour={selectedHour}
                />
              </>
            )}
            {selectedOrder && (
              <OrderDetail
                order={selectedOrder}
                updateplat={updatePlatillo}
                selectedDay={selectedDay}
                selectedHour={selectedHour}
              />
            )}
          </>
        ) : (
          <>
            <Board
              itemsOrd={orders?.map((item) => {
                let newI = { ...item };
                newI.detalle = item.detalle?.filter((ite) => {
                  if (
                    ite.selectedDate === selectedDay &&
                    (ite.selectedTime === selectedHour ||
                      selectedHour === "cantidad")
                  ) {
                    return true;
                  }
                  let fech = new Date(item.fecha.seconds * 1000);
                  let dateord = fech.toISOString().split("T")[0];
                  let hora = fech.toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: false, // Set to true for AM/PM
                  });
                  if (
                    (!ite.selectedDate ||
                      (ite.selectedDate === selectedDay &&
                        !ite.selectedTime)) &&
                    dateord === selectedDay &&
                    (hora === selectedHour || selectedHour === "cantidad")
                  ) {
                    return true;
                  }
                  return false;
                });
                if (newI.detalle?.length > 0) {
                  return newI;
                } else {
                  return undefined;
                }
              })}
              updatePlatillo={updatePlatillo}
              selectedDate={selectedDay}
            />
          </>
        )}
        <Modal
          show={verificar}
          onHide={() => {
            setVerificar(false);
            setMarOrd();
          }}
        >
          <ModalHeader>Marcar entrega</ModalHeader>
          <ModalBody>¿Marcar la orden {marOrd?.folio} para entrega?</ModalBody>
          <ModalFooter>
            <Button
              variant="secondary"
              onClick={() => {
                setVerificar(false);
              }}
            >
              CERRAR
            </Button>
            <Button variant="primary" onClick={updateStatus}>
              ENTRGAR
            </Button>
          </ModalFooter>
        </Modal>

        {/* <div className="timeline">
        {hourSummary.map((hour) => (
          <TimelineItem key={hour.id} item={hour} />
        ))}
      </div> */}
      </>
    </div>
  );
};

export default Cocina;
